import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/user-management/edit-role/index.html';

const links: Record<string, string> = {
  users: '/infoTrac/user-management',
  roles: '/infoTrac/user-management/roles',
  apps: '/infoTrac/user-management/apps',
  roleSaved: '/infoTrac/user-management/roles?act=roleSaved',
};

function UserManagementEditRole() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const users = iframeDocument.getElementById('users');
      const roles = iframeDocument.getElementById('roles');
      const apps = iframeDocument.getElementById('apps');

      const submit = iframeDocument.getElementById('submitBtn');

      if (users) users.addEventListener('click', () => navigate(links.users));
      if (roles) roles.addEventListener('click', () => navigate(links.roles));
      if (apps) apps.addEventListener('click', () => navigate(links.apps));

      if (submit) submit.addEventListener('click', () => navigate(links.roleSaved));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="user-management-edit-role" src={path} width="100%" height="1200px" />;
}

export default UserManagementEditRole;
